var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatioicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.316,
    height: 13.316,
    viewBox: "0 0 13.316 13.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14400",
    "data-name": "Group 14400",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14399",
    "data-name": "Group 14399",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14401",
    "data-name": "Group 14401",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5370",
    "data-name": "Rectangle 5370",
    width: 12.316,
    height: 12.316,
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11303",
    "data-name": "Path 11303",
    d: "M16.061,6.94h3.609V10.55",
    transform: "translate(-9.404 -3.892)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11304",
    "data-name": "Path 11304",
    d: "M10.55,19.671H6.94V16.061",
    transform: "translate(-3.892 -9.404)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_745",
    "data-name": "Line 745",
    x1: 7.219,
    y2: 7.219,
    transform: "translate(3.049 3.048)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatioicon);
export default __webpack_public_path__ + "static/media/ratioicon.fa5f6cc1add13903313bdc50e447f598.svg";
export { ForwardRef as ReactComponent };